import React from 'react';

import { SVGComponentProps } from './svg.types';

const HeadingTwoSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <path
          d="M3 11H4.33V8.06483H7.54V11H8.88V4.09655H7.54V7.03172H4.33V4.09655H3V11Z"
          fill="#55585E"
        />
        <path
          d="M9.83977 11H15.0098V10.0055H11.9698L13.5598 8.50897C14.4098 7.71724 14.9598 6.93517 14.9598 6.03724C14.9598 4.82069 14.0798 4 12.5998 4C11.0898 4 10.1498 4.86897 10.0598 6.37517H11.2798C11.3998 5.4 11.8498 5.00414 12.5598 5.00414C13.2498 5.00414 13.6298 5.40965 13.6298 6.05655C13.6298 6.7131 13.2198 7.32138 12.5398 8.01655L9.83977 10.7683V11Z"
          fill="#55585E"
        />
        <rect x="3" y="15" width="18" height="1" fill="#BCBEC2" />
        <rect x="3" y="17" width="18" height="1" fill="#BCBEC2" />
        <rect x="3" y="19" width="10" height="1" fill="#BCBEC2" />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      </svg>
    </span>
  );
};

export default HeadingTwoSVG;
